import SettingConfig from '../config/setting';
import type { GuideCarouselCardData } from '../types/card/type';

// PC - 외부 앱 방송하기 - LIVE 방송
export const externalLiveGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 외부 앱 방송하기 이동',
      explanationSentenceList: [
        '홈페이지 상단 오른쪽 방송하기 버튼 클릭',
        '외부 앱에서 방송하기\n방송시작 버튼 클릭 (로그인 및 본인인증 후 가능)',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_live1.png`,
  imgClass: '-translate-y-[75px]',
  imgContainerClass: 'h-[504px]',
};

export const externalLiveGuideStepTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 2. 스트림키 발급받기',
      explanationSentenceList: [
        '최초 설정 시 방송설정 저장 후 스트림키 발급 가능',
        '방송설정 및 아이템 설정하기\n- 방송제목 입력\n- 방송속성: 19금 방송, 비밀번호 ON/OFF\n- 비밀번호 설정 (비밀번호 ON시 표기)\n- 방송 카테고리 선택\n- 방송 형태 선택 (일반방송, 유료방송, 팬방송)\n- 시청인원 설정\n- 아이템 설정 (해당하는 아이템을 보유하고 있을 시 설정 가능)',
        '알림설정  완료하기(방송 설정 안내 및  아이템 사용 여부 등을 \n알림톡으로 발송)',
        '적용하기 버튼 클릭 후 스트림키 발급 완료',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_live2.png`,
  imgClass: '-translate-y-[55px]',
  imgContainerClass: 'h-[890px]',
};

export const externalLiveGuideStepThree: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 송출 프로그램 연결하기',
      explanationSentenceList: [
        '발급 받은 스트림키, 서버 URL 확인 후\n복사 아이콘 클릭하여 복사하기',
        'OBS Studio / PRISM Live Studio / Streamlabs OBS 설정하기\n복사한 스트림키, 서버 URL 캠 플레이어에 붙여넣기',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_live3.png`,
  imgClass: '-translate-y-[55px]',
  imgContainerClass: 'h-[540px]',
};

export const externalLiveGuideStepFour: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 4. 방송시작 및 확인하기',
      explanationSentenceList: [
        '스트림키, 서버 URL 설정한 캠 플레이어에서\n방송시작 버튼 클릭 후 방송 송출\n(OBS Studio / PRISM Live Studio / Streamlabs OBS)',
        ' LIVE 아이콘 및 안내 문구 변경으로 방송 시작 확인',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_live4.png`,
  imgClass: '-translate-y-[60px]',
  imgContainerClass: 'h-[504px]',
};

export const externalLiveGuideStepFive: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 5. 방송시작 및 확인하기',
      explanationSentenceList: [
        '스트림키, 서버 URL 설정한 캠 플레이어에서\n방송시작 버튼 클릭 후 방송 송출\n(OBS Studio / PRISM Live Studio / Streamlabs OBS)',
        'LIVE 버튼 클릭하여 방송 확인',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_live_5.png`,
};

// PC - 외부 앱 방송하기 - 녹화 방송
export const externalRecordGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 방송내역 이동',
      explanationSentenceList: [
        '로그인 후 홈페이지 상단 프로필 버튼 클릭',
        `'채널' 클릭`,
        `채널 상단 탭에서 '방송내역'클릭`,
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_record_1.png`,
};

export const externalRecordGuideStepTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 2. 방송 다운로드',
      subTitle: '별도로 녹화를 하지 않아도 방송 종료 후 방송내역에서 확인 가능\n(최근 7일간)',
      explanationSentenceList: [
        '파일 준비 버튼 클릭',
        `파일 변환 준비중`,
        `파일 변환 완료, 다운로드 글자 클릭`,
        `다운로드 받을 파일 버튼 클릭 (최대 5회 다운로드 가능)`,
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_record_2.png`,
};

export const externalRecordGuideStepThree: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 다운로드 받은 방송 적용하기',
      explanationSentenceList: [
        `캠 플레이어에서 소스추가 '+' 버튼 클릭
(OBS Studio / PRISM Live Studio / Streamlabs OBS)`,
        '미디어 소스 버튼 클릭',
        `다운로드 받은 방송 적용`,
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_record_3.png`,
};

export const externalRecordGuideStepFour: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 4. 녹화방송 시작 및 확인하기',
      explanationSentenceList: [
        `스트림키, 서버 URL 설정한 캠 플레이어에서
방송시작 버튼 클릭 후 적용한 녹화 방송 송출
(OBS Studio / PRISM Live Studio / Streamlabs OBS)`,
        `LIVE 버튼 클릭하여 방송 확인`,
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_pc_record_4.png`,
};

// PC - 캠 프로그램 - 매니캠
export const programManyCamGuideOne: GuideCarouselCardData = {
  contents: [
    {
      title: '',
      explanationSentenceList: [
        '확대/축소',
        '캠 및 캠 연결 프로그램 선택',
        '해상도 설정 (고화질 720p)',
        '밝기/색 대비 조정',
        'R.G.B 설정',
        '화면분할 설정',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_1_1.png`,
  rightBottomText: '[해당 버전 :7.3.0.7]',
};

export const programManyCamGuideTwo: GuideCarouselCardData = {
  contents: [
    {
      title: '',
      explanationSentenceList: [
        '텍스트 삽입 및 색,효과 설정',
        '캠 및 캠 연결 프로그램 선택',
        '이미지 및 동영상 파일 선택',
        'BJ 화면 노출 설정',
        '모든 화면 노출',
        '마우스 이동 화면 노출',
        '지정한 화면 노출',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_1_2.png`,
  rightBottomText: '[해당 버전 :7.3.0.7]',
};

// PC - 캠 프로그램 - You Cam
export const programYouCamGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      title: '1. 설정',
      explanationSentenceList: [
        '설정 선택',
        '방송 장비 캠 선택',
        '해상도 선택',
        '좌우 대칭 설정',
        '비디오 확대 축소 설정',
      ],
    },
    {
      title: '2. 방송 향상',
      explanationSentenceList: ['방송 향상 선택', '피부 효과 설정', '방송 화면 선명도 설정'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_2_1.png`,
  rightBottomText: '[해당 버전 :9.0.1029.0]',
};

// PC - 캠 프로그램 - XSplit
export const programXSplitGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      explanationSentenceList: [
        '로그인 선택 (필수)',
        '프레임, 해상도 선택',
        '장면 전환 효과 선택',
        '전환 장면 추가',
        '지정된 화면 캡쳐',
        '실행중인 게임 자동 캡쳐',
        '방송장비 캠 캡쳐',
        '웹페이지 url 추가',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_3_1.png`,
  rightBottomText: '[해당 버전 :3.9.1912.1008]',
};

// PC - 캠 프로그램 - 연동사용
export const programXSplitYouCamCombinationGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 엑스스플릿 설정',
      explanationSentenceList: ['소스 추가', '장치 (웹캠, 캠처 보드 등) 선택', '영상 선택', '방송 장비 캠 선택'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_4_1.png`,
  rightBottomText: '[해당 버전 :3.9.1912.1008]',
};

export const programXSplitYouCamCombinationGuideStepTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 2. 유캠 설정',
      explanationSentenceList: ['유캠 실행 후 설정 선택', '캡처장치 XSplit Broadcaster 선택'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_4_2.png`,
  rightBottomText: '[해당 버전 :9.0.1029.0]',
};

export const programXSplitManycamCombinationGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 엑스스플릿 설정',
      explanationSentenceList: [
        '소스 추가',
        '장치 (웹캠, 캠처 보드 등) 선택',
        '영상 선택',
        'XSplit Vcam(XSplit Broadcaster) 선택',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/x_many_1.png`,
  rightBottomText: '[해당 버전 :3.9.1912.1008]',
};

export const programXSplitManycamCombinationGuideStepTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 2. 매니캠 설정',
      explanationSentenceList: ['매니캠 실행 후 화면 클릭', 'XSplit Broadcaster 선택'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/x_many_2.png`,
  rightBottomText: '[해당 버전 :7.3.0.7]',
};

export const programYoucamManycamCombinationGuideStepOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 유캠 설정',
      explanationSentenceList: ['설정 선택', '방송 장비 캠 선택', '해상도 선택'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/you_many_1.png`,
  rightBottomText: '[해당 버전 :9.0.1029.0]',
};

export const programYoucamManycamCombinationGuideStepTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 2. 매니캠 설정',
      explanationSentenceList: ['매니캠 실행 후 화면 클릭', 'CyberLink YouCam 9 선택'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/you_many_2.png`,
  rightBottomText: '[해당 버전 :7.3.0.7]',
};

// 모바일

// 모바일 - 카메라방송
export const mobileCameraGuideOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 방송 시작하기',
      explanationSentenceList: ['방송하기'],
    },
    {
      title: 'STEP 2. 옵션설정',
      subTitle: '모바일 카메라로 방송할 경우, 본 화면(카메라모드)에서 다양한 옵션을 설정',
      explanationSentenceList: [
        '',
        '성인방송 ON/OFF',
        '비번방 ON/OFF',
        '입장효과음 ON/OFF',
        '방송모드 선택',
        '방송제목 변경 (최대 20자)',
        '방송, 아이템 설정',
        '전/후면 카메라 설정',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_camera_1.png`,
};

export const mobileCameraGuideTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 방송설정',
      subTitle: '설정 버튼으로 옵션 설정 가능',
      explanationSentenceList: [
        '방송형태: 일반방송, 유료방송, 팬방송 중 형태 하나 선택',
        '카테고리: 방송 컨셉 혹은 테마가 속하는 카테고리 선택',
        '시청인원: 방송에 입장할 수 있는 최대 시청자수를 설정',
      ],
    },
    {
      title: 'STEP 4. 아이템설정',
      subTitle: '방송 아이템을 이용하여 보다 많은 시청자들과 소통 가능',
      explanationSentenceList: [
        '',
        '',
        '',
        '시청인원 UP: 방송에 참여할 수 있는 최대인원 증가',
        '리스트업: 내 방송을 상단에 노출',
        '리스트꾸미기: 내 방송의 배경 이미지 설정',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_camera_2.png`,
};

export const mobileCameraGuideThree: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 5. 방송설정 완료',
      subTitle: '모든 설정 저장 후 카메라 버튼 누른 후 방송 시작',
      explanationSentenceList: ['카메라방송 시작'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_camera_3.png`,
};

// 모바일 - 라이브캠
export const mobileLiveCamGuideOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 방송 시작하기',
      subTitle: '방송준비 화면에서 좌우 스와이프 혹은 화면 하단의 라이브캠 버튼 선택',
      explanationSentenceList: ['방송하기'],
    },
    {
      title: 'STEP 2. 옵션설정',
      subTitle: '카메라방송모드와 동일한 방법으로 방송 및 아이템 설정',
      explanationSentenceList: ['', '성인방송 ON/OFF', '비번방 ON/OFF', '입장효과음 ON/OFF', '방송, 아이템 설정'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_live_1.png`,
};

export const mobileLiveCamGuideTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 추가 옵션설정',
      subTitle: '방송 시작 후 홈화면으로 이동한 뒤 추가 옵션설정 가능',
      explanationSentenceList: [
        '시청자 수',
        '소리 ON/OFF',
        '셀카모드 ON/OFF',
        '방송/아이템설정 노출',
        '시청화면(전체화면)으로 이동',
      ],
    },
    {
      title: 'STEP 4. 방송종료',
      subTitle: `라이브캠 방송 종료 시 팬더아이콘을 '닫기'버튼까지 드래그`,
      explanationSentenceList: [],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_live_2.png`,
};

// 모바일 - 텍스트자막
export const mobileTextGuideOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 텍스트자막 추가',
      subTitle: `방송 시작 후 채팅입력창 우측 '방송효과' 버튼을 통해 텍스트자막 추가`,
      explanationSentenceList: ['방송하기', '텍스트자막'],
    },
    {
      title: 'STEP 2. 텍스트 등록',
      subTitle: `'+'버튼 누른 후 다양한 텍스트 등록 (최대 3개 가능)`,
      explanationSentenceList: ['', '', '텍스트 편집', '삭제', '노출 ON/OFF'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_text_1.png`,
};

export const mobileTextGuideTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 텍스트 꾸미기',
      subTitle: `텍스트의 컬러, 정렬, 굵기, 배경색 등 다양한 꾸미기 활용 가능`,
      explanationSentenceList: ['텍스트 꾸미기 설정'],
    },
    {
      title: 'STEP 4. 크기 조절',
      subTitle: `텍스트 사이즈를 조절한 후 우측 상단의 '저장'버튼으로 방송화면 적용`,
      explanationSentenceList: ['', '텍스트 크기 조절'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_text_2.png`,
};

export const mobileTextGuideThree: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 5. 방송화면 적용 완료',
      subTitle: `관리기능을 통해 언제나 알맞은 텍스트로 재설정 가능`,
      explanationSentenceList: [],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_text_3.png`,
};

// 모바일 - 이미지삽입
export const mobileImageGuideOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 이미지삽입',
      subTitle: `방송 시작 후 '방송효과' 아이콘 > 이미지삽입을 통해 시청자에게 이미지공개 가능`,
      explanationSentenceList: ['이미지삽입'],
    },
    {
      title: 'STEP 2. 이미지등록',
      subTitle: `'+'버튼 누른 후 휴대폰에 저장된 이미지를 첨부`,
      explanationSentenceList: ['', '이미지추가'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_img_add_1.png`,
};

export const mobileImageGuideTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 이미지설정',
      subTitle: `썸네일을 누르면 이미지삽입 가능`,
      explanationSentenceList: ['이미지편집', '삭제', '노출 ON/OFF'],
    },
    {
      title: 'STEP 4. 크기 조절',
      subTitle: `삽입한 이미지의 크기 조절 후 저장`,
      explanationSentenceList: ['', '', '', '사이즈 조절'],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_img_add_2.png`,
};

export const mobileImageGuideThree: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 5. 방송화면 적용 완료',
      subTitle: `관리기능을 통해 다양한 이미지로 설정 가능`,
      explanationSentenceList: [],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_img_add_3.png`,
};

// 모바일 - 도우미위젯
export const mobileHelperWidgetGuideOne: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 1. 도우미위젯 추가',
      subTitle: `방송 시작 후 '방송효과' 아이콘 > 도우미위젯을 설정`,
      explanationSentenceList: ['도우미위젯'],
    },
    {
      title: 'STEP 2. 위젯설정',
      explanationSentenceList: [
        '',
        '알림 ON/OFF: 후원 및 추천을 알림 표시',
        '목표치 ON/OFF: 하트 후원 목표 설정',
        '후원자막 ON/OFF: 후원 내용을 갯수별, 순위별 등 다양한 형태 표시',
        '상세설정: 위젯의 다양한 옵션을 설정할 수 있는 상세설정 페이지로 이동',
      ],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_img_help_1.png`,
};

export const mobileHelperWidgetGuideTwo: GuideCarouselCardData = {
  contents: [
    {
      title: 'STEP 3. 크기조절',
      subTitle: `위젯의 사이즈를 조절, 기타 다양한 옵션설정을 원할 경우 상세설정 페이지로 이동`,
      explanationSentenceList: ['위젯 크기조절'],
    },
    {
      title: 'STEP 4. 방송화면 적용 완료',
      subTitle: '관리기능을 통해 시청자들과 함께 소통하는 방송 만들기',
      explanationSentenceList: [],
    },
  ],
  imgSrc: `${SettingConfig.S3_BUCKET_URL}/img/guide/guide_mobile_img_help_2.png`,
};
